var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26698 6.12305C5.7977 7.46204 5.53144 8.87372 5.47144 10.3505H10.4128V6.12305H6.26698Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41419 2.15444C7.76986 3.0036 7.23056 3.89519 6.7959 4.82568H10.4126V0C9.85704 0.489052 9.13294 1.20715 8.41419 2.15444Z",
    fill: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10692 6.12305C0.463583 7.43221 0.0853434 8.86358 0 10.3505H4.1738C4.22974 8.89207 4.47494 7.47576 4.90524 6.12305H1.10692Z",
    fill: "#545454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47241 11.6484C5.53937 13.2381 5.84759 14.6489 6.27866 15.8759H10.4126V11.6484H5.47241Z",
    fill: "#545454"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80615 17.1719C7.31416 18.265 7.90055 19.1712 8.44538 19.8842C9.15718 20.8156 9.86677 21.5191 10.4125 21.9994V17.1719H6.80615V17.1719Z",
    fill: "#545454"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8233 6.12305H11.71V10.3505H16.6295C16.5626 8.76071 16.2543 7.34993 15.8233 6.12305Z",
    fill: "#545454"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1738 11.6484H0C0.0853434 13.1353 0.463583 14.5667 1.10692 15.8759H4.90524C4.47494 14.5232 4.22974 13.1068 4.1738 11.6484Z",
    fill: "#545454"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6565 2.11269C12.9537 1.19304 12.253 0.495482 11.71 0.015625V4.82503H15.2957C14.7878 3.73189 14.2013 2.82566 13.6565 2.11269Z",
    fill: "#545454"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2232 3.1721C2.71062 3.68468 2.25494 4.23883 1.8584 4.82665H5.38226V4.8267C5.90205 3.58893 6.58423 2.41368 7.41487 1.32666C7.70988 0.940612 8.00468 0.590561 8.28998 0.275391C6.38946 0.761248 4.64659 1.74876 3.2232 3.1721Z",
    fill: "#545454"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41487 20.6719C6.58419 19.5849 5.90205 18.4096 5.38226 17.1719H1.8584C2.25494 17.7597 2.71062 18.3139 3.2232 18.8264C4.64663 20.2498 6.3895 21.2373 8.28998 21.7231C8.00468 21.408 7.70988 21.058 7.41487 20.6719Z",
    fill: "#545454"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.72 17.1719C16.2002 18.4096 15.518 19.5848 14.6874 20.6719C14.3923 21.058 14.0976 21.408 13.8123 21.7231C15.7128 21.2373 17.4556 20.2498 18.879 18.8264C19.3916 18.3138 19.8473 17.7597 20.2438 17.1719H16.72Z",
    fill: "#545454"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.71 17.1719V21.9793C12.2628 21.4907 12.9779 20.7786 13.6877 19.8431C14.332 18.9939 14.8713 18.1024 15.306 17.1719H11.71Z",
    fill: "#545454"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.879 3.17206C17.4556 1.74868 15.7127 0.761162 13.8123 0.275391C14.0976 0.590518 14.3923 0.940525 14.6874 1.32662C15.518 2.41364 16.2002 3.58889 16.72 4.82665H20.2438C19.8473 4.23879 19.3916 3.6846 18.879 3.17206Z",
    fill: "#545454"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9953 6.12305H17.197C17.6273 7.47576 17.8725 8.89211 17.9285 10.3505H22.1022C22.0169 8.86358 21.6386 7.43221 20.9953 6.12305Z",
    fill: "#545454"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.71 11.6484V15.8759H15.8352C16.3045 14.5369 16.5707 13.1252 16.6307 11.6484H11.71Z",
    fill: "#545454"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9282 11.6484C17.8723 13.1068 17.6271 14.5231 17.1968 15.8759H20.9951C21.6384 14.5667 22.0166 13.1353 22.102 11.6484H17.9282Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.eeeab8ad5d2a7277ef1aab17b24343d1.svg";
export { ForwardRef as ReactComponent };